<template>
  <div>
    <header>
      <span>{{schoolName}}教练员注册证</span>
      <section>
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
        <el-button style="width:90px;margin:0 10px 0 20px;" type="warning" @click="print">打印</el-button>
        <el-button type="primary" style="width:90px" v-if="false">导出PDF</el-button>
      </section>
    </header>
    <div id="studentRegist">
      <ul class="student_regist" style="display:flex;flex-wrap:wrap;list-style:none">
        <li v-for="(item,index) in list" :key="index" style="border: 1px solid #979797;width: 370px;padding: 30px 10px 30px 20px;">
          <section class="head_img">
            <img :src="item.headImage" alt />
          </section>
          <section class="student_info_box">
            <ul class="student_info_left">
              <li>
                <p class="left_width">
                  姓名
                  <span>{{item.name}}</span>
                </p>
                <p class="right_width">
                  性别
                  <span>{{!item.gender?'女':'男'}}</span>
                </p>
              </li>
              <li>
                <p class="left_width">
                  民族
                  <span>{{item.nation}}</span>
                </p>
                <p class="right_width">
                  出生
                  <span>{{item.birthday}}</span>
                </p>
              </li>
              <li>
                <p>
                  学校
                  <span>{{item.schoolName}}</span>
                </p>
              </li>
              <li>
                <p>
                  类别
                  <span>{{item.type === 1?'阳光体育':'竞技项目'}}</span>
                </p>
              </li>
              <li>
                <p>
                  注册号
                  <span>{{item.registerNumber}}</span>
                </p>
              </li>
              <li>
                <p>
                  有效期
                  <span>{{effectiveTime(item.trainingTime,item.trainingEndTime)}}</span>
                </p>
              </li>
            </ul>
          </section>
        </li>
      </ul>
    </div>
    <el-pagination
      v-if="list.length > 0"
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <coachRegistrationPrint  :list='list' ref="coachRegist"></coachRegistrationPrint>
  </div>
</template>
<script>
import coachRegistrationPrint from './components/coach-registration-print';
import { getCoachList } from "@/api/coach";
import { page } from "@/common/js/mixins";
import { method } from "@/utils/utils";
import registerData from "@/assets/json/register.json";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page],
  components:{
    coachRegistrationPrint
  },
  data() {
    return {
      list: [],
      query: {
        keyword: ""
      },
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    registGroup() {
      return data => {
        let label = "";
        registerData.registGroup.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 有效期
    effectiveTime() {
      return (data, end) => {
        return data + " 至 " + end;
      };
    }
  },
  methods: {
    // 打印
    print() {
      var el = document.querySelector("#coachRegist"),
        iframe = document.createElement("IFRAME"),
        doc = null;
      iframe.setAttribute("id", "print-iframe");
      iframe.setAttribute(
        "style",
        "width:100%;font-size:20px;text-align:center"
      );
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
      doc.write(
        '<html><head><style type="text/css" media="all">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;}</style></head><body style="zoom: 80%;">' +
          el.innerHTML +
          "</body></html>"
      );
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      getCoachList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          res.list.filter(item => {
            item.birthday = method.timeFormat(item.birthday, "utf");
            item.trainingTime = item.trainingTime
              ? method.timeFormat(item.trainingTime, "utf")
              : "";
            item.trainingEndTime = item.trainingEndTime
              ? method.timeFormat(item.trainingEndTime, "utf")
              : "";
          });
          this.list = [...res.list];
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
header {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  > span {
    font-size: 24px;
    color: #222;
    margin-right: 36px;
  }
}
.student_regist {
  display: flex;
  flex-wrap: wrap;
  > li {
    border: 1px solid #979797;
    width: 380px;
    padding: 30px 10px 30px 20px;
    margin: 0 16px 16px 0;
    .head_img {
      width: 160px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .student_info_box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      color: #444;
      .student_info_left,
      .student_info_right {
        width: 100%;
        li {
          font-size: 16px;
          margin-bottom: 10px;
          display: flex;
          font-weight: 600;
          align-items: flex-start;
          &.empty {
            visibility: hidden;
          }
          .right_width {
            width: 150px;
          }
          .left_width {
            flex: 1;
          }
          span {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>